import { useMemo } from 'react';
import { CpgReport } from '../../campaigns/subdomains/cpg/api/schema';
import { AIInsights, MetricsType } from '../domain/ai-insights';

type AIInsightsHook = {
  cpgAiInsights: AIInsights | null;
};

export const useCpgAIInsights = (
  report: Pick<CpgReport, 'aiInsights'> | null,
  metricsType: MetricsType,
  dimensionName: string | null = null
): AIInsightsHook => {
  return useMemo(() => {
    const matchingInsight = (report?.aiInsights ?? []).find(
      i => i.metricsType === metricsType && i.dimensionName === dimensionName
    );
    if (!matchingInsight) return { cpgAiInsights: null };

    return {
      cpgAiInsights: matchingInsight,
    };
  }, [dimensionName, metricsType, report?.aiInsights]);
};
